
import * as React from 'react'
import styled, { css } from 'styled-components'
import { useSelector } from 'react-redux'
import IconButton from './Navigation/IconButton'
import { AppState } from '../../store'

const Title = styled.div`
  padding: 8px 4px;
  font-weight: bold;
  text-align: center;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  gap: 8px;
  align-items: center;
`

const Container = styled.div<{ themed?: boolean, hidden?: boolean, border?: boolean }>`
  min-height: fit-content;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 8px;
  background: white;
  color: rgb(115, 115, 115);
  gap: 8px;
  
  // ANIMATION
  transition: min-height 150ms ease-out, max-height 150ms ease-out, background-color 150ms ease-in-out;
  /* min-height: 115.5px;
  max-height: 115.5px; */

  ${Title} {
    color: black;
  }

  ${({ themed }) => themed && css`
    color: rgba(255, 255, 255, 0.7);
    background: ${({ theme }) => theme.color.background};

    ${Title} {
      color: ${({ theme }) => theme.color.backgroundText};
    }

    ${IconButton} {
      color: ${({ theme }) => theme.color.backgroundText}

      &:hover {
        background: transparent;
      }
    }
  `}

  ${({ hidden }) => hidden && css`
    display: none;
  `}

  ${({ border }) => border && css`
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  `}
`

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  min-height: 48px;
  font-size: 18px;
  color: rgb(255, 255, 255);
`

const LeftSection = styled.div`
  display: flex;
  flex: 1 1 0%;
  justify-content: flex-start;
`

const RightSection = styled.div`
  display: flex;
  flex: 1 1 0%;
  justify-content: flex-end;
`

const BottomSection = styled.div`
  width: 100%;
`

const TopNavigation = () => {
  const {
    themed,
    bottom,
    left,
    right,
    title,
    hidden,
    border,
  } = useSelector((state: AppState) => state.navigation)

  return (
    <Container themed={themed} hidden={hidden} border={border}>
      <Wrapper>
        <LeftSection>{left}</LeftSection>

        <Title>{title}</Title>

        <RightSection>{right}</RightSection>
      </Wrapper>

      {bottom && <BottomSection>
        {bottom}
      </BottomSection>}
    </Container>
  )
}

export default TopNavigation